import { get, post, req } from '@/plugins/axios'
import { blankBar } from '@/util/useFormat'

/**
 * 店铺钱包
 * @param {Object} params
 */
export function getCustomerWallet (params: any) {
  return get('/settlement/wallet/getCustomerWallet', { params })
}

/**
 * 店铺钱包列表
 */
export function getCustomerWalletList (params: { stationCode?: string, currencyCode?: string }) {
  return get('/settlement/wallet/getCustomerWalletList', { params })
}

export function isNeedNewFundUser () {
  return post('/settlement/wallet/queryFundFlow/isNeedNewFundUser')
}

/**
 * 查看店铺消费记录
 * @param {Object} data
 */
export function queryFundFlow (data: any) {
  return post('/settlement/wallet/queryFundFlow/es', data).format(blankBar)
}

/**
 * 查看店铺消费记录
 * @param {Object} data
 */
export function queryFundFlow_old (data: any) {
  return post('/settlement/wallet/queryFundFlow', data).format(blankBar)
}

/**
 * 获取费用类型
 */
export function getFundType () {
  return get('/settlement/wallet/getFundFlowRespDTO')
}

/**
 * 获取账户未入账金额
 */
export function getUnCheckMoney (params?:any) {
  return get('/settlement/wallet/getCustomerUnCheckMoney', { params })
}

/**
 * 余额充值-申请
 */
export function rechargeApply (data: any) {
  return post('/settlement/recharge/manager/balance/apply', data)
}

/**
 * 余额充值-回显
 */
export function rechargeGet (data: any) {
  return req('/settlement/recharge/manager/balance/latest/info/get', data)
}

/**
 * 转账
 * @param {*} data
 */
export const walletTransferOut = (data: any) => {
  return post('/settlement/wallet/walletTransferOut', data)
}

/**
 * 获取可转账的账号列表
 * @param {*} data
 */
export const getCanTransformList = () => {
  return get('/customer/getCanTransformList')
}

/**
 * 提现-发送邮件(获取验证码)
 * @param {*} data
 */
export const sendEmailGetCode = (data: any) => {
  return req('/settlement/withdraw/manager/send/withdraw/email', data)
}

/**
 * 提现-获取提现信息(可提现金额,当前汇率,费率)
 * @param {*} data
 */
export const getWithdrawalMsg = (config: any) => {
  return get('/settlement/withdraw/manager/apply/info/get', config)
}

/**
 * 提现-获取计算后的手续费和提现金额
 * @param {*} data
 */
export const getCalculateAmount = (data: any) => {
  return req('/settlement/withdraw/manager/apply/amount/calculate', data)
}

/**
 * 提现-申请提现
 * @param {*} data
 */
export const applyWithdrawal = (data: any) => {
  return post('/settlement/withdraw/manager/apply', data)
}

/**
 * 详情
 * @param {*} data
 */
export const getFlowOneById = (params: any) => {
  return get('/settlement/wallet/getFlowOneById', { params })
}

/**
 * 余额充值-上传凭证
 * @param {*} data
 */
export const uploadVoucher = (data: any) => {
  return post('/settlement/recharge/manager/balance/voucher/upload', data)
}

/**
 * 余额充值-判断是否有票据可以下载
 * @param {*} data
 */
export const isDownload = (params: any) => {
  return get('/settlement/recharge/manager/has/can/download/balance/recharge', {
    params
  })
}

/**
 * 获取主账号钱包
 * @param {*} data
 */
export const getMainCustomerWallet = (data: any) => {
  return req('/settlement/wallet/getMainCustomerWallet', data)
}

/**
 * 余额充值-派安盈分页列表
 * @param {*} data
 */
export const getPayoneerList = (params: any) => {
  return get('/settlement/recharge/manager/balance/payoneer/query', { params })
}

/**
 * 用户账单分页查询（客户端）
 * @param {*} data
 */
export const getBillListApi = (params: any) => {
  return get('/settlement/customer/bill/query/for/customer', { params })
}

/**
 * 支付客户账单
 * @param {*} data
 */
export const payBillApi = (data: any) => {
  return post(
    '/settlement/customer/bill/pay/' +
    data.customerBillId +
    '?mainOrSubBill=' +
    data.mainOrSubBill,
    data
  )
}

/**
 * 拒绝支付客户账单
 * @param {*} data
 */
export const refusedBillApi = (data: any) => {
  return post('/settlement/customer/bill/pay/refused', data)
}

/**
 * 获取用户待支付总额
 * @param {*} data
 */
export const getBillAmountApi = (params: any) => {
  return get('/settlement/customer/bill/get/customer/need/pay/amount', {
    params
  })
}

/**
 * 获取需要支付账单数量
 * @param {*} data
 */
export const getBillCountApi = (params: any) => {
  return post('/settlement/customer/bill/get/all/need/pay/count', params)
}

/**
 * 用户钱包明细详情
 * @param {*} data
 */
export const getCustomerCashBackDetailApi = (params: any) => {
  return post('/settlement/back/money/wallet/detail', params)
}

/**
 * 充值记录
 * @param {*} data
 */
export const getBalanceHistoryListApi = (params: any) => {
  return get('/settlement/recharge/manager/balance/select/list', { params })
}

/**
 * 会员充值记录
 * @param {*} data
 */
export const getVipHistoryListApi = (params: any) => {
  return post(
    '/settlement/wallet/recharge/membership/getCustomerMembershipOrder',
    params
  )
}

/**
 * 导出用户会员充值订单
 * @param {*} data
 */
export const exportCustomerMembershipOrderApi = (params: any) => {
  return post(
    '/settlement/wallet/recharge/membership/exportCustomerMembershipOrder',
    params
  )
}

/**
 * 保存用户银行卡信息
 * @param {*} data
 */
interface SCBIA {
  bankName: string;
  bankCardNo: string;
  bankBranchName: string;
  bankBranchCode: string;
  bankAccountName: string;
  customerBankCardId?: number;
}
export const saveCustomerBankInfoApi = (params: SCBIA) => {
  return post('/settlement/customer/bank/card/save', params)
}

/**
 * 获取用户银行卡信息
 * @param {*} data
 */
export const getCustomerBankListApi = (data: any) => {
  return post('/settlement/customer/bank/card/query', data)
}

/**
 * 删除用户银行卡
 * @param {*} data
 */
export const delCustomerBankApi = (customerBankCardId: number) => {
  return post('/settlement/customer/bank/card/delete/' + customerBankCardId)
}

/**
 * 余额充值-WF充值记录提交
 * @param {*} data
 */
export const wfBlanceSubmitApi = (data: any) => {
  return post('/settlement/recharge/manager/wf/balance/submit', data)
}

/**
 * wf金额待入账金额
 * @param {*} data
 */
export const getWfTotalPriceApi = (data: any) => {
  return post('/settlement/recharge/manager/balance/query/total', data)
}

/**
 * 银行名称列表
 * @param {*} data
 */
export const getWfBlankListApi = (data: any) => {
  return post('/settlement/base/bank/query', data)
}

/**
 * 订单资金明细
 * @param {*} data
 */
export const getOrderFundDetailApi = (data: any) => {
  return req('/settlement/wallet/fund/flow/international/express/get', data)
}

/**
 * 获取账单信息
 * @param {Object} params
 */
export function getBillInfo (params: any) {
  return get('/settlement/bill/info', { params })
}

/**
 * 账单信息导出
 * @param {Object} params
 */
export function getBillInfoExport (params: any) {
  return get('/settlement/bill/info/export', {
    responseType: 'arraybuffer',
    params
  })
}

/** 导出Excel（导出sku费用明细） */
export const skuFundDetailExport = (params: any): any =>
  get('/settlement/wallet/download/skuFundDetailByPlatformOrderNo', {
    responseType: 'arraybuffer',
    params
  })

/**
 * 账单信息导出
 * @param {Object} params
 */
export function exportShelvedRecordApi (data: any) {
  return post('/order/customer/platformOrder/exportShelvedRecord', { ...data, responseType: 'arraybuffer' })
}
